import React from 'react';
import classnames from 'classnames';
import RemoveBtn from 'assets/svg/bin-red.svg';
import classes from './remove-icon-button.scss';
export const RemoveIconButton = ({
  onClick,
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.itemCardRemoveBtn, className),
    onClick: onClick,
    "data-button": "Delete"
  }, /*#__PURE__*/React.createElement("img", {
    src: RemoveBtn,
    alt: "Icon of a red trash bin, indicating a delete function or waste disposal"
  }));
};